import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab37823c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brandManager" }
const _hoisted_2 = { class: "search_div" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "品牌名：", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查找")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("门店管理")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_13 = { class: "my-header" }
const _hoisted_14 = ["id"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, { title: "品牌管理" }),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_el_select, {
          modelValue: _ctx.brandName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.brandName) = $event)),
          clearable: "",
          filterable: "",
          placeholder: "请选择品牌名"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandList, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.brand_name,
                value: item.brand_name
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.getBrandLists
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showBrand()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        border: "",
        style: {"width":"100%"},
        "header-row-class-name": "tb_bg"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "brand_id",
            label: "财升品牌ID",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "brand_name",
            label: "品牌名",
            width: "250"
          }),
          _createVNode(_component_el_table_column, {
            prop: "account",
            label: "品牌管理员账号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "count",
            label: "门店数",
            width: "80"
          }),
          _createVNode(_component_el_table_column, { label: "状态" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.is_enable==0?'禁用':'启用'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            fixed: "right",
            width: "260px"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: ($event: any) => (_ctx.showBrand(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: ($event: any) => (_ctx.compMana(scope.row.id,scope.row.brand_id))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: ($event: any) => (_ctx.delBrands(scope.row.id,scope.row.user_id,scope.row.role_id))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.brandDialog,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.brandDialog) = $event)),
      title: _ctx.form.id?'编辑品牌':'新增品牌',
      width: "400px",
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeInfo('form')))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.queryClick
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeInfo('form')))
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          "label-width": "120px",
          "label-position": "left",
          rules: _ctx.rules,
          ref: "brandDiaForm",
          class: "brand_from"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "品牌名",
              prop: "brand_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.brand_name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.brand_name) = $event)),
                  placeholder: "请输入品牌名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "财升品牌ID",
              prop: "brand_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.brand_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.brand_id) = $event)),
                  type: "number",
                  placeholder: "请一定输入正确的财升品牌ID"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "品牌管理员账号",
              prop: "account"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.account,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.account) = $event)),
                  disabled: _ctx.form.id?true:false,
                  placeholder: "该账号拥有品牌管理最高权限"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "品牌管理员密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.password,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.password) = $event)),
                  placeholder: "默认yc123456"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "品牌开通功能",
              prop: "checkMenu"
            }, {
              default: _withCtx(() => [
                (_ctx.brandDialog)
                  ? (_openBlock(), _createBlock(_component_el_tree, {
                      key: 0,
                      data: _ctx.menuTree,
                      props: _ctx.defaultProps,
                      "node-key": "id",
                      "show-checkbox": "",
                      onCheckChange: _ctx.handleCheckChange,
                      "default-checked-keys": _ctx.defaultCheck,
                      "default-expand-all": ""
                    }, null, 8, ["data", "props", "onCheckChange", "default-checked-keys"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "is_enable"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.form.is_enable,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.is_enable) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showCompany,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showCompany) = $event)),
      "show-close": false,
      width: "700px"
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h4", {
            id: titleId,
            class: _normalizeClass(titleClass)
          }, "门店管理", 10, _hoisted_14),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.companyAE()))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.companyList,
          border: "",
          style: {"width":"100%"},
          "header-row-class-name": "tb_bg"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "company_id",
              label: "财升门店ID"
            }),
            _createVNode(_component_el_table_column, {
              prop: "premises_id",
              label: "音创场所ID"
            }),
            _createVNode(_component_el_table_column, {
              prop: "store_name",
              label: "门店名"
            }),
            _createVNode(_component_el_table_column, {
              prop: "scene",
              label: "场景值"
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  text: "",
                  type: "primary",
                  onClick: ($event: any) => (_ctx.companyAE(scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  text: "",
                  type: "primary",
                  onClick: ($event: any) => (_ctx.delCompany(scope.row.id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.companyDialog,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.companyDialog) = $event)),
      title: _ctx.companyForm.id?'编辑门店':'新增门店',
      width: "400px",
      onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.closeInfo('companyForm')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.companyForm,
          "label-width": "120px",
          "label-position": "left",
          rules: _ctx.rules,
          ref: "companyDiaForm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "财升门店ID",
              prop: "company_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.companyForm.company_id,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.companyForm.company_id) = $event)),
                  type: "number"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "音创场所ID",
              prop: "premises_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.companyForm.premises_id,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.companyForm.premises_id) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "门店名",
              prop: "store_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.companyForm.store_name,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.companyForm.store_name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "场景值",
              prop: "scene"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.companyForm.scene,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.companyForm.scene) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.companyClick
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.closeInfo('companyForm')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}